import { Severity, SpreadsheetMapping, ValidationIssue } from 'api'

export const severityError = (issue: ValidationIssue) => issue.severity === Severity.ERROR

export const spreadsheetMappingSortByLastSetAsDefaultPredicate = (s1: SpreadsheetMapping, s2: SpreadsheetMapping) => {
  if (s1.lastSetAsDefault === null) {
    return 1
  }
  if (s2.lastSetAsDefault === null) {
    return -1
  }
  return s1.lastSetAsDefault < s2.lastSetAsDefault ? 1 : s1.lastSetAsDefault > s2.lastSetAsDefault ? -1 : 0
}
